// @ts-nocheck
import * as Types from '../../../../lib/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { myFetcher } from '@src/lib/fetchConfig.dtc';
export type MenuItemFragmentFragment = { __typename: 'MenuItem', title?: string | null, linkUrl?: string | null, sys: { __typename?: 'Sys', id: string }, entry?: { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | null };

export type PageFragmentFragment = { __typename: 'Page', title?: string | null, slug?: string | null };

export type SubMenuItemFragmentFragment = { __typename: 'SubMenuItem', title?: string | null, linkUrl?: string | null, sys: { __typename?: 'Sys', id: string }, entry?: { __typename?: 'Page', slug?: string | null } | null };

export type MainHeaderContentFragmentFragment = { __typename: 'MainHeaderContent', title?: string | null, subTitle?: string | null, sys: { __typename?: 'Sys', id: string } };

export type MainHeaderMenuQueryVariables = Types.Exact<{
  preview?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type MainHeaderMenuQuery = { __typename?: 'Query', headerCollection?: { __typename?: 'HeaderCollection', items: Array<{ __typename?: 'Header', title?: string | null, content?: { __typename?: 'HeaderContentCollection', items: Array<{ __typename?: 'AnnualReviewHeader', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Author', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlueshiftCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlueshiftTags', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Button', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Collection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ContactPoint', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Faq', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FaqEntry', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FeaturedBlogPost', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FlexDisplay', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FlexDisplayItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Footer', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Footnote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FourZeroFour', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Header', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Heading', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MainContactForm', sys: { __typename?: 'Sys', id: string } } | (
          { __typename?: 'MainHeaderContent', sys: { __typename?: 'Sys', id: string } }
          & MainHeaderContentFragmentFragment
        ) | { __typename?: 'MainSiteHero', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MainSiteHeroMenuItems', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MediaAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MigrationVersion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NascarLogo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NascarLogos', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'OrgContactInfo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Organization', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageBlogIndex', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageBlogPost', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageErrorPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageGenericPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PageLandingPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Person', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Post', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTypes', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Redirect', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RichContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Section', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Settings', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShareButton', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShareButtons', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SourceTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SubMenuItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Tabs', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeamMember', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Testimonial', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Testimonials', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TestimonialsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TwoStackColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'VideoTopic', sys: { __typename?: 'Sys', id: string } } | null> } | null, menuItemsCollection?: { __typename?: 'HeaderMenuItemsCollection', items: Array<(
          { __typename?: 'MenuItem' }
          & MenuItemFragmentFragment
        ) | (
          { __typename?: 'Page' }
          & PageFragmentFragment
        ) | (
          { __typename?: 'SubMenuItem' }
          & SubMenuItemFragmentFragment
        ) | null> } | null } | null> } | null, subMenuItemCollection?: { __typename?: 'SubMenuItemCollection', items: Array<{ __typename: 'SubMenuItem', title?: string | null, linkUrl?: string | null, sys: { __typename?: 'Sys', id: string }, entry?: { __typename?: 'Page', slug?: string | null } | null, menuItemsCollection?: { __typename?: 'SubMenuItemMenuItemsCollection', items: Array<(
          { __typename?: 'MenuItem' }
          & MenuItemFragmentFragment
        ) | (
          { __typename?: 'Page' }
          & PageFragmentFragment
        ) | (
          { __typename?: 'SubMenuItem' }
          & SubMenuItemFragmentFragment
        ) | null> } | null } | null> } | null, menuItemCollection?: { __typename?: 'MenuItemCollection', items: Array<{ __typename?: 'MenuItem', title?: string | null, linkUrl?: string | null, sys: { __typename?: 'Sys', id: string }, entry?: { __typename?: 'Page', slug?: string | null } | null } | null> } | null };

export const MenuItemFragmentFragmentDoc = `
    fragment menuItemFragment on MenuItem {
  sys {
    id
  }
  title
  __typename
  linkUrl
  entry(preview: $preview) {
    sys {
      id
    }
    slug
    __typename
  }
}
    `;
export const PageFragmentFragmentDoc = `
    fragment pageFragment on Page {
  __typename
  title
  slug
}
    `;
export const SubMenuItemFragmentFragmentDoc = `
    fragment subMenuItemFragment on SubMenuItem {
  sys {
    id
  }
  title
  linkUrl
  entry(preview: $preview) {
    slug
  }
  __typename
}
    `;
export const MainHeaderContentFragmentFragmentDoc = `
    fragment mainHeaderContentFragment on MainHeaderContent {
  sys {
    id
  }
  title
  subTitle
  __typename
}
    `;
export const MainHeaderMenuDocument = `
    query MainHeaderMenu($preview: Boolean) {
  headerCollection(preview: $preview, where: {title: "SHD Header"}) {
    items {
      title
      content: contentCollection(preview: $preview, limit: 1) {
        items {
          sys {
            id
          }
          ...mainHeaderContentFragment
        }
      }
      menuItemsCollection(preview: $preview, limit: 5) {
        items {
          ...menuItemFragment
          ...subMenuItemFragment
          ...pageFragment
        }
      }
    }
  }
  subMenuItemCollection(preview: $preview) {
    items {
      sys {
        id
      }
      title
      linkUrl
      entry {
        slug
      }
      __typename
      menuItemsCollection(limit: 10) {
        items {
          ...subMenuItemFragment
          ...menuItemFragment
          ...pageFragment
        }
      }
    }
  }
  menuItemCollection(preview: $preview) {
    items {
      sys {
        id
      }
      title
      linkUrl
      entry(preview: $preview) {
        slug
      }
    }
  }
}
    ${MainHeaderContentFragmentFragmentDoc}
${MenuItemFragmentFragmentDoc}
${SubMenuItemFragmentFragmentDoc}
${PageFragmentFragmentDoc}`;
export const useMainHeaderMenuQuery = <
      TData = MainHeaderMenuQuery,
      TError = unknown
    >(
      variables?: MainHeaderMenuQueryVariables,
      options?: UseQueryOptions<MainHeaderMenuQuery, TError, TData>
    ) =>
    useQuery<MainHeaderMenuQuery, TError, TData>(
      variables === undefined ? ['MainHeaderMenu'] : ['MainHeaderMenu', variables],
      myFetcher<MainHeaderMenuQuery, MainHeaderMenuQueryVariables>(MainHeaderMenuDocument, variables),
      options
    );

useMainHeaderMenuQuery.getKey = (variables?: MainHeaderMenuQueryVariables) => variables === undefined ? ['MainHeaderMenu'] : ['MainHeaderMenu', variables];
;

useMainHeaderMenuQuery.fetcher = (variables?: MainHeaderMenuQueryVariables, options?: RequestInit['headers']) => myFetcher<MainHeaderMenuQuery, MainHeaderMenuQueryVariables>(MainHeaderMenuDocument, variables, options);